export enum ResponseMessage {
    SUCCESS = "success",
    DANGER = "danger",
    WARNING = "warning",
}
